import React from "react";

function DownloadIcon() {
  return (
    <span className="anticon anticon-download">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 19 19"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          stroke="transparent"
          strokeOpacity="0"
          d="M3.2 12.4v3.4h12.6v-3.4h2.7v3.9c0 .608-.246 1.158-.644 1.556a2.193 2.193 0 01-1.556.644h0H2.7a2.193 2.193 0 01-1.556-.644A2.193 2.193 0 01.5 16.3h0v-3.9h2.7zM10.85.5v8.29l2.299-2.298 1.91 1.909L9.5 13.959 3.942 8.401l1.909-1.91 2.299 2.3V.5h2.7z"
        ></path>
      </svg>
    </span>
  );
}

export default DownloadIcon;
